import { i18n } from '@lingui/core'
import { Label, Paragraph, Small } from '../text/Text'

interface ContactInfoProps {
  contact?: {
    email: string
    salutation: string
    firstName: string
    lastName: string
    company: string
    telefon: string
  }
}

export function ContactInfo({ contact }: ContactInfoProps) {
  return (
    <>
      <Label id="section-contact">{i18n._('Ansprechpartner')}</Label>
      {contact?.firstName && contact?.lastName && (
        <Paragraph className="text-black">
          {contact.firstName} {contact.lastName}
        </Paragraph>
      )}
      <div className="flex flex-col my-2 break-words">
        {contact?.company && <Small>{contact.company}</Small>}
        {contact?.telefon && <Small>{contact.telefon}</Small>}
        {contact?.email && (
          <Small className="text-accent">
            <a href={`mailto:${contact.email}`}>{contact.email}</a>
          </Small>
        )}
      </div>
    </>
  )
}

export default ContactInfo
